import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import MaterialTable from 'material-table';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

import * as OrdersManagerClient from '../clients/OrdersManager';
import * as ProductsManagerClient from '../clients/ProductsManager';

const styles = (theme) => ({
    root: {
        padding: 40,
        position: 'relative',
    },
    card: {
        width: 200,
        marginBottom: '1rem',
    },
    cardOrderLimits: {
        // width: 300,
        marginBottom: '1rem',
    },
    ordersTextField: {
        width: '100%',
    },
});
class Admin extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            alertOpen: false,
            alertMessage: '',
            alertSeverity: 'success',
            activeStep: 0,
            loading: true,
            products: undefined,
            totalProducts: 0,
            totalExpired: 0,
            totalOnSale: 0,

            ordersPerHour: -1,
            ordersPerHourChanged: false,

            ordersPerDayMonday: -1,
            ordersPerDayTuesday: -1,
            ordersPerDayWednesday: -1,
            ordersPerDayThursday: -1,
            ordersPerDayFriday: -1,
            ordersPerDaySaturday: -1,
            ordersPerDaySunday: -1,
            ordersPerDayChanged: false,
        };
    }

    componentDidMount() {
        ProductsManagerClient.getAllNoPaging().then((products) => {
            let now = new Date();
            let totalExpired = 0;
            let totalOnSale = 0;
            products.forEach((p) => {
                if (p.dateTo !== undefined) {
                    if (new Date(p.dateTo) < now) {
                        totalExpired++;
                    } else if (new Date(p.dateTo) >= now && (p.dateFrom === undefined || new Date(p.dateFrom) <= now)) {
                        totalOnSale++;
                    }
                } else if (p.dateFrom !== undefined) {
                    if (new Date(p.dateFrom) <= now) {
                        totalOnSale++;
                    }
                }
            });
            this.setState({ products: products, totalExpired, totalOnSale, totalProducts: products.length });
        });

        OrdersManagerClient.getStoreAvailabilityOrdersPerHour().then((ordersPerHour) => this.setState({ ordersPerHour }));
        OrdersManagerClient.getMaxOrdersPerDay().then((weekdays) => {
            this.setState({
                ordersPerDayMonday: weekdays[0],
                ordersPerDayTuesday: weekdays[1],
                ordersPerDayWednesday: weekdays[2],
                ordersPerDayThursday: weekdays[3],
                ordersPerDayFriday: weekdays[4],
                ordersPerDaySaturday: weekdays[5],
                ordersPerDaySunday: weekdays[6],
            });
        });
    }

    showMessage = (alertMessage, alertSeverity) => {
        this.setState({ alertMessage, alertSeverity, alertOpen: true });
    };

    handleClose = () => {
        this.setState({ alertOpen: false });
    };

    refreshList = () => {
        OrdersManagerClient.invalidateCache();
        this.tableRef.current && this.tableRef.current.onQueryChange();
        OrdersManagerClient.getMissingPostalCodes().then((data) => this.setState({ data }));
    };

    handleOrdersPerHourChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value, ordersPerHourChanged: true });
    };

    handleSaveOrdersPerHour = () => {
        OrdersManagerClient.setStoreAvailabilityOrdersPerHour(this.state.ordersPerHour)
            .then((ordersPerHour) => {
                this.setState({ ordersPerHourChanged: false, ordersPerHour });
                this.showMessage('Pedidos por hora actualizados!', 'success');
            })
            .catch((err) => this.showMessage('No se ha podido actualizar los pedidos por hora', 'error'));
    };

    handleOrdersPerDayChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value, ordersPerDayChanged: true });
    };

    handleSaveOrdersPerDay = () => {
        OrdersManagerClient.setMaxOrdersPerDay([
            this.state.ordersPerDayMonday,
            this.state.ordersPerDayTuesday,
            this.state.ordersPerDayWednesday,
            this.state.ordersPerDayThursday,
            this.state.ordersPerDayFriday,
            this.state.ordersPerDaySaturday,
            this.state.ordersPerDaySunday,
        ])
            .then((weekdays) => {
                this.setState({
                    ordersPerDayMonday: weekdays[0],
                    ordersPerDayTuesday: weekdays[1],
                    ordersPerDayWednesday: weekdays[2],
                    ordersPerDayThursday: weekdays[3],
                    ordersPerDayFriday: weekdays[4],
                    ordersPerDaySaturday: weekdays[5],
                    ordersPerDaySunday: weekdays[6],
                    ordersPerDayChanged: false,
                });
                this.showMessage('Pedidos por día actualizados!', 'success');
            })
            .catch((err) => this.showMessage('No se ha podido actualizar los pedidos por día', 'error'));
    };

    render() {
        return (
            <div className={this.props.classes.root}>
                <Snackbar autoHideDuration={6000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.alertOpen} onClose={this.handleClose}>
                    <MuiAlert elevation={6} variant="filled" severity={this.state.alertSeverity} onClose={this.handleClose}>
                        {this.state.alertMessage}
                    </MuiAlert>
                </Snackbar>
                <Grid container justify="space-around" direction="row">
                    <div>
                        <Card className={this.props.classes.card}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Total productos
                                </Typography>
                                <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                                    {this.state.totalProducts}
                                </Typography>
                            </CardContent>
                        </Card>

                        <Card className={this.props.classes.card}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Total ofertas válidas
                                </Typography>
                                <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                                    {this.state.totalOnSale}
                                </Typography>
                            </CardContent>
                        </Card>

                        <Card className={this.props.classes.card}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom style={{ color: 'red' }}>
                                    Total ofertas caducadas
                                </Typography>
                                <Typography variant="h5" component="h2" style={{ textAlign: 'center', color: 'red' }}>
                                    {this.state.totalExpired}
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                    <div>
                        <Card className={this.props.classes.cardOrderLimits}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Límite Pedidos <strong>Recogida en Tienda</strong>
                                </Typography>
                                {this.state.ordersPerHour === -1 ? (
                                    <div style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <>
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Pedidos por hora"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerHour}
                                            name="ordersPerHour"
                                            onChange={this.handleOrdersPerHourChange}
                                        />
                                        <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                                            <Button
                                                startIcon={<SaveRoundedIcon />}
                                                variant="contained"
                                                color="primary"
                                                disabled={this.state.ordersPerHourChanged === false}
                                                onClick={this.handleSaveOrdersPerHour}
                                            >
                                                Guardar
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </CardContent>
                        </Card>
                        <Card className={this.props.classes.cardOrderLimits}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Límite diario Pedidos <strong>a Domicilio</strong>
                                </Typography>{' '}
                                {this.state.ordersPerDayMonday === -1 ? (
                                    <div style={{ textAlign: 'center' }}>
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <>
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Lunes"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDayMonday}
                                            name="ordersPerDayMonday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Martes"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDayTuesday}
                                            name="ordersPerDayTuesday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Miércoles"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDayWednesday}
                                            name="ordersPerDayWednesday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Jueves"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDayThursday}
                                            name="ordersPerDayThursday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Viernes"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDayFriday}
                                            name="ordersPerDayFriday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Sábado"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDaySaturday}
                                            name="ordersPerDaySaturday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <TextField
                                            className={this.props.classes.ordersTextField}
                                            label="Domingo"
                                            type="number"
                                            InputProps={{ inputProps: { min: 0, max: 250, style: { textAlign: 'right' } } }}
                                            value={this.state.ordersPerDaySunday}
                                            name="ordersPerDaySunday"
                                            onChange={this.handleOrdersPerDayChange}
                                        />
                                        <br />
                                        <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                                            <Button
                                                startIcon={<SaveRoundedIcon />}
                                                variant="contained"
                                                color="primary"
                                                disabled={this.state.ordersPerDayChanged === false}
                                                onClick={this.handleSaveOrdersPerDay}
                                            >
                                                Guardar
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </CardContent>
                        </Card>
                    </div>
                    <MaterialTable
                        title="C.P. sin servicio"
                        style={{ minWidth: '600px' }}
                        tableRef={this.tableRef}
                        columns={[
                            {
                                field: 'id',
                                title: 'Código Postal',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                render: (rowData) => <span>{rowData['id'].replace('MPC-', '')}</span>,
                            },
                            {
                                field: 'totalMiss',
                                title: 'Intentos',
                                editable: 'never',
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                            },
                        ]}
                        data={(query) =>
                            new Promise((resolve, reject) => {
                                OrdersManagerClient.getMissingPostalCodes(query.page + 1, query.pageSize, query.search).then((result) => {
                                    resolve({
                                        data: result.data,
                                        page: result.page - 1,
                                        totalCount: result.total,
                                    });
                                });
                            })
                        }
                        options={{
                            search: true,
                            pageSize: 10,
                            actionsColumnIndex: -1,
                        }}
                        localization={{
                            pagination: {
                                labelDisplayedRows: '{from}-{to} de {count}',
                            },
                            toolbar: {
                                nRowsSelected: '{0} filas(s) seleccionadas',
                                searchTooltip: 'Buscar',
                                searchPlaceholder: 'Buscar',
                            },
                            header: {
                                actions: '',
                            },
                            body: {
                                emptyDataSourceMessage: 'No hay datos a mostrar',
                                filterRow: {
                                    filterTooltip: 'Filtro',
                                },
                            },
                        }}
                        actions={[
                            {
                                icon: 'refresh',
                                tooltip: 'Refresh Data',
                                isFreeAction: true,
                                onClick: () => this.refreshList(),
                            },
                        ]}
                    />
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Admin);
